/**
 * This is to add correct screen reader behaviour for telephone links.
 * If a user specifies tel: in their href in a block, we set it as the aria label.
 * This will be read out as 'telephone + (number)'
 */
const mainContent = document.getElementById('main');

if (mainContent) {
  const links = mainContent.getElementsByTagName('a');

  // Iterate through links and add SR capability where appropriate.
  for (let i = 0; i < links.length; i += 1) {
    const element = links[i];
    // tel: should be added in Gutenberg to trigger the correct behaviour.
    if (element?.href?.slice(0, 4) === 'tel:') {
      element.setAttribute('aria-label', `Phone number: ${element.innerHTML}`);
    }
  }
}
